import {ListVehicleFinancingTemplateResponseBody} from '@dms/api/sales';

import {getOrderedVehicleFinancingTemplates} from './getOrderedVehicleFinancingTemplates';

export interface VehicleFinancingTemplatesByAutomaticOrder {
  /** Templates the automatic assignment evaluates, in evaluation order. Only these may be dragged. */
  inAutomaticOrder: ListVehicleFinancingTemplateResponseBody[];
  /** Everything else of the same type — rendered read-only, never given an automatic position. */
  outsideAutomaticOrder: ListVehicleFinancingTemplateResponseBody[];
}

/**
 * An archived template keeps its last automatic position but is no longer evaluated, and a template
 * that was never enrolled has no position at all (`automatic: false`, `automaticPosition: null`).
 * Reordering must not hand either of them a fresh draggable position, so the two groups are split
 * here once and consumed by every surface that renders the order. The backend reorder payload is a
 * separate complete-order contract that still includes archived automatic members.
 */
export function splitVehicleFinancingTemplatesByAutomaticOrder(
  templates: ListVehicleFinancingTemplateResponseBody[],
  type: ListVehicleFinancingTemplateResponseBody['type']
): VehicleFinancingTemplatesByAutomaticOrder {
  const orderedTemplates = getOrderedVehicleFinancingTemplates(templates, type);
  const inAutomaticOrder = orderedTemplates.filter(
    (template) => !template.archived && template.automatic
  );
  const outsideAutomaticOrder = orderedTemplates.filter(
    (template) => template.archived || !template.automatic
  );

  return {inAutomaticOrder, outsideAutomaticOrder};
}
